
<v-container>
	<v-form ref="locumQualificationsForm" v-model="valid" class="pa-4 pt-0 text-wrap">
		<template v-if="allowOptionalFormalTraining">
			<v-row>
				<v-col class="pb-0">
					<v-checkbox
						v-model="noFormalTraining"
						:label="getLabel('educationNoFormalTraining', 'I don’t have formal training.')"
						hide-details
						class="mt-0 mb-3"
						@change="onNoFormalTrainingChange"
					></v-checkbox>
				</v-col>
			</v-row>
			<v-row>
				<v-col class="pt-0">
					<v-checkbox
						v-model="learnedOnTheJob"
						:label="getLabel('educationLearnedOnTheJob', 'I have experience and learned on the job')"
						hide-details
						class="mt-0"
					></v-checkbox>
				</v-col>
			</v-row>
		</template>

		<v-row
			><v-col>
				<v-text-field
					v-model="qualification"
					:outlined="true"
					:disabled="fieldsOptional"
					:label="getLabel('educationSectionPrimaryQualification', 'Primary Qualification')"
					:rules="qualifactionRules"
				></v-text-field> </v-col
		></v-row>

		<v-row
			><v-col>
				<v-text-field
					v-model="collegeuniversity"
					:outlined="true"
					:disabled="fieldsOptional"
					:label="getLabel('educationSectionCollege', 'College/University')"
					:rules="collegeuniversityRules"
				></v-text-field> </v-col
		></v-row>

		<v-row
			><v-col>
				<v-menu
					ref="qualificationYearMenu"
					v-model="qualificationYearMenu"
					pt-1
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					max-width="320px"
					min-width="290px"
					:disabled="fieldsOptional"
				>
					<template #activator="{ on }">
						<v-text-field
							v-model="dateFormatted"
							outlined
							class="pb-3"
							:disabled="fieldsOptional"
							:label="getLabel('educationSectionDateQualified', 'Date Qualified')"
							persistent-hint
							hint="Select or type the date (DD/MM/YYYY)"
							:rules="yearqualifiedRules"
							@blur="setDate"
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker v-model="qualificationDate" :max="new Date().toISOString()" no-title @input="qualificationYearMenu = false"></v-date-picker>
				</v-menu> </v-col
		></v-row>

		<v-row
			><v-col>
				<v-text-field
					v-model="otherqualifications"
					:outlined="true"
					label="Other Qualifications"
					messages="(Optional) Additional qualifications, diplomas, courses, certificates"
				></v-text-field> </v-col
		></v-row>
	</v-form>
	<v-row v-if="solo">
		<v-btn text @click="reset">Clear</v-btn>
		<v-spacer></v-spacer>
		<v-btn class="white--text" color="deep-purple accent-4" depressed @click="SubmitForm()">Update</v-btn>
	</v-row>
</v-container>
